import styles from "../styles/Booking.module.css";
import { useEffect } from "react";
const Booking = () =>{
        useEffect(() => {
        window._hors = [['eid', 'hydra-7e45baa5-5dac-4d8a-9904-c454fdc43745'],
            ['tagid', 'hydra-7e45baa5-5dac-4d8a-9904-c454fdc43745'],
            ['width', '100%'],
            ['height', ''],
            ['foregroundColor', ''],
            ['backgroundColor', ''],
            ['linkColor', ''],
            ['errorColor', ''],
            ['primaryButtonForegroundColor', ''],
            ['primaryButtonBackgroundColor', ''],
            ['secondaryButtonForegroundColor', ''],
            ['secondaryButtonBackgroundColor', '']];

        setTimeout(() => {
            const script = document.createElement('script');
            script.src = 'https://reservation.dish.co/widget.js';
            script.async = true;
            document.body.appendChild(script);

            return () => {
                document.body.removeChild(script);
            };
        }, 1000);
    }, []);
    return (
      <>
          <section className={styles.heroContainer}>
              <div className={styles.overlay}>
                  <h1 className={styles.title}>Tisch Reservieren</h1>
              </div>
          </section>
             {/* <div id="hydra-7e45baa5-5dac-4d8a-9904-c454fdc43745"></div> */}
          <div>
            <div id="hydra-7e45baa5-5dac-4d8a-9904-c454fdc43745"></div>
          </div>
      </>
    )
}
const ComingSoonMenu = () => {
    return (
        <div className={styles.container}>
            <div className={styles.menuBox}>
                <h1 className={styles.titleComingSoon}>Tisch Reservieren</h1>
                <p className={styles.message}>
                    Tisch Reservieren wird in Kürze aktualisiert
                </p>
                <div className={styles.icon}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                    </svg>
                </div>
            </div>
        </div>
    );
};

export default Booking;